function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  transition: all 300ms;\n  margin-right: 10px;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  background: rgba(211, 215, 220, 0.32);\n  padding: 0.5em 1em;\n  display: block;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  border: 0.75px solid #d3d7dc;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 6px 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import React, { useCallback } from "react";
import propTypes from "prop-types";
import { FaRegTrashAlt, FaCaretDown, FaPlus, FaTimes, FaRev } from "react-icons/fa";
import { FiMove } from "react-icons/fi";
import IconButton from "../IconButton";
import BreakdownTable from "./BreakdownTable";
import { WrRow as Row, WrCol as Col } from "../../../grid";
import Button from "../../../button";
import styled from "styled-components";
import * as phasesModule from "../../../../modules/phases";
import Card, { CardBody, CardHeader as _CardHeader } from "../../../../components/card";
import { PhaseAllocationsActionsEnum } from "../stateReducer";
import Tooltip from "../../../Tooltip";
import { buildConfirmationModal } from "../../../modal/builders";
import { context } from "../../../wr-context";
import { ConfirmationText } from "./styles";
import { ModalScalingFactorsEnum } from "../../../modal/modal";
var CollapseIcon = styled(FaCaretDown)(_templateObject(), function(props) {
    return !props.$isExpanded && "transform: rotate(-90deg);";
}, function(props) {
    return props.$isDisabled && "opacity: 0.5;";
}, function(props) {
    return !props.$isDisabled && "cursor: pointer;";
});
var CardHeader = styled(_CardHeader)(_templateObject1());
var StyledCard = styled(Card)(_templateObject2());
// Padding instead of margin for better DnD behaviour
var Container = styled.div(_templateObject3());
// interface DefaultRenderHeaderProps extends Required<PhasesRenderHeaderProps> {
//   renderDelete: ({ disabled }: { disabled?: boolean }) => React.ReactNode
//   renderAdditionalControls: (options: PhasesRenderHeaderProps) => React.ReactNode
//   displayDiscountedPrice?: boolean
// }
var defaultRenderHeader = function(options) {
    var renderToggle = options.renderToggle, renderName = options.renderName, renderDelete = options.renderDelete, renderDragHandle = options.renderDragHandle, renderAdditionalControls = options.renderAdditionalControls, detailedCost = options.detailedCost, formatCurrency = options.formatCurrency, displayDiscountedPrice = options.displayDiscountedPrice;
    return /*#__PURE__*/ React.createElement(Row, {
        middle: "xs"
    }, /*#__PURE__*/ React.createElement(Col, {
        xs: true
    }, renderToggle(options), renderName(options)), /*#__PURE__*/ React.createElement(Col, {
        xs: true,
        $noGrow: true,
        style: {
            whiteSpace: "nowrap"
        }
    }, renderAdditionalControls && renderAdditionalControls(options), "\xa0\xa0\xa0\xa0", formatCurrency(detailedCost.fullCost / 100), displayDiscountedPrice && " / ", displayDiscountedPrice && formatCurrency(detailedCost.discountedCost / 100), "\xa0\xa0\xa0\xa0", renderDelete(options), "\xa0\xa0\xa0\xa0", renderDragHandle(options)));
};
export default function ItemRow(props) {
    var itemRow = props.itemRow, itemGroup = props.itemGroup, selectedRegion = props.selectedRegion, dispatch = props.dispatch, dragHandleProps = props.dragHandleProps, innerRef = props.innerRef, formatCurrency = props.formatCurrency, isDisabledCb = props.isDisabledCb, getClassName = props.getClassName, effortUnit = props.effortUnit, usesDecimalNumbers = props.usesDecimalNumbers, customComponents = props.customComponents, hideDropdownsRow = props.hideDropdownsRow, rest = _objectWithoutProperties(props, [
        "itemRow",
        "itemGroup",
        "selectedRegion",
        "dispatch",
        "dragHandleProps",
        "innerRef",
        "formatCurrency",
        "isDisabledCb",
        "getClassName",
        "effortUnit",
        "usesDecimalNumbers",
        "customComponents",
        "hideDropdownsRow"
    ]);
    var detailedCost = phasesModule.utils.calculateItemRowCost(itemRow, {
        rateOverrideKey: selectedRegion,
        getDiscount: props.getDiscount,
        getPrice: props.getAddonPrice
    });
    var disabled = isDisabledCb({
        itemRow: itemRow,
        itemGroup: itemGroup
    });
    var onAllocationChange = useCallback(function(ev) {
        var n = ev.target.value;
        if (typeof n === "string") n = n.replace(/[^0-9.]/, "");
        if (usesDecimalNumbers) {
            if (n.startsWith("0") && !n.includes(".")) {
                n = n.replace("0", "");
            }
        } else {
            n = +n;
        }
        var ref = _slicedToArray(ev.target.name.split("."), 2), i = ref[0], j = ref[1];
        dispatch({
            type: PhaseAllocationsActionsEnum.UpdateData,
            y: +i,
            x: +j,
            hours: n
        });
    }, [
        dispatch
    ]);
    var onPhaseChange = useCallback(function(e, phase, phaseIndex) {
        if (phase) dispatch({
            type: PhaseAllocationsActionsEnum.UpdatePhase,
            phaseIndex: phaseIndex,
            phase: phase
        });
    }, [
        dispatch
    ]);
    var onAddRole = useCallback(function() {
        return dispatch({
            type: PhaseAllocationsActionsEnum.AddRole
        });
    }, [
        dispatch
    ]);
    var onRemoveRole = useCallback(function(roleIndex) {
        return dispatch({
            type: PhaseAllocationsActionsEnum.RemoveRole,
            roleIndex: roleIndex
        });
    }, [
        dispatch
    ]);
    var onRoleChange = useCallback(function(e, role, roleIndex) {
        if (role) dispatch({
            type: PhaseAllocationsActionsEnum.UpdateRole,
            role: role,
            roleIndex: roleIndex
        });
    }, [
        dispatch
    ]);
    var onToggle = function() {
        if (itemRow.phasesBreakdown) dispatch({
            type: PhaseAllocationsActionsEnum.ToggleExpanded
        });
    };
    var handleWeekRemove = function() {
        context.actions.openModal(buildConfirmationModal({
            body: /*#__PURE__*/ React.createElement(ConfirmationText, null, "Are you sure you want to delete the last week?"),
            size: ModalScalingFactorsEnum.xsm,
            onConfirm: function() {
                return dispatch({
                    type: PhaseAllocationsActionsEnum.RemoveWeek
                });
            }
        }));
    };
    var handleServiceDelete = function() {
        context.actions.openModal(buildConfirmationModal({
            body: /*#__PURE__*/ React.createElement(ConfirmationText, null, "Are you sure you want to delete the ", itemRow.item.name, " service?"),
            onConfirm: function() {
                return dispatch({
                    type: PhaseAllocationsActionsEnum.RemoveItemRow
                });
            }
        }));
    };
    var handleResetValues = function() {
        context.actions.openModal(buildConfirmationModal({
            body: /*#__PURE__*/ React.createElement(ConfirmationText, null, "Are you sure you want to reset to default values for this item?"),
            onConfirm: function() {
                return dispatch({
                    type: PhaseAllocationsActionsEnum.Reset
                });
            },
            size: ModalScalingFactorsEnum.xsm
        }));
    };
    var renderToggle = function() {
        return /*#__PURE__*/ React.createElement(CollapseIcon, {
            onClick: onToggle,
            $isExpanded: itemRow.isExpanded,
            $isDisabled: !itemRow.phasesBreakdown
        });
    };
    var renderName = function() {
        return itemRow.item.name;
    };
    var renderDelete = function(param) {
        var disabled = param.disabled;
        return /*#__PURE__*/ React.createElement(IconButton, {
            disabled: disabled
        }, /*#__PURE__*/ React.createElement(Tooltip, {
            tooltip: "Delete",
            style: {
                display: "inline-flex"
            }
        }, /*#__PURE__*/ React.createElement(FaRegTrashAlt, {
            onClick: handleServiceDelete
        })));
    };
    var renderDragHandle = function(param) {
        var dragHandleProps = param.dragHandleProps, disabled = param.disabled;
        return /*#__PURE__*/ React.createElement(IconButton, _extends({
            disabled: disabled
        }, dragHandleProps), /*#__PURE__*/ React.createElement(FiMove, null));
    };
    return /*#__PURE__*/ React.createElement(Container, _extends({}, rest, {
        ref: innerRef,
        className: (getClassName === null || getClassName === void 0 ? void 0 : getClassName({
            type: "itemRow",
            props: props,
            containerProps: rest
        })) || ""
    }), /*#__PURE__*/ React.createElement(StyledCard, null, /*#__PURE__*/ React.createElement(CardHeader, null, props.renderHeader({
        renderHeader: defaultRenderHeader,
        renderToggle: renderToggle,
        renderName: renderName,
        renderDelete: renderDelete,
        renderDragHandle: renderDragHandle,
        dispatch: dispatch,
        itemGroup: itemGroup,
        itemRow: itemRow,
        detailedCost: detailedCost,
        dragHandleProps: dragHandleProps,
        formatCurrency: formatCurrency,
        disabled: disabled,
        effortUnit: effortUnit
    })), itemRow.isExpanded && /*#__PURE__*/ React.createElement(React.Fragment, null, props.displayItemRowControls && /*#__PURE__*/ React.createElement(CardBody, {
        style: {
            padding: 20
        }
    }, /*#__PURE__*/ React.createElement(Row, {
        middle: "xs",
        end: "xs",
        $gap: "10px"
    }, /*#__PURE__*/ React.createElement(Col, null, /*#__PURE__*/ React.createElement(IconButton, {
        onClick: handleResetValues
    }, /*#__PURE__*/ React.createElement(Tooltip, {
        options: {
            placement: "left"
        },
        tooltip: "Reset to default values",
        style: {
            display: "inline-flex"
        }
    }, /*#__PURE__*/ React.createElement(FaRev, null), " "))), /*#__PURE__*/ React.createElement(Col, null, !!itemRow.phasesBreakdown.phases.length && /*#__PURE__*/ React.createElement(Tooltip, {
        tooltip: "Delete Last Week",
        options: {
            placement: "left"
        },
        style: {
            display: "inline-flex"
        }
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: handleWeekRemove
    }, /*#__PURE__*/ React.createElement(FaTimes, null), " Remove Week"))), /*#__PURE__*/ React.createElement(Col, null, /*#__PURE__*/ React.createElement(Button, {
        onClick: function() {
            return dispatch({
                type: PhaseAllocationsActionsEnum.AddWeek
            });
        }
    }, /*#__PURE__*/ React.createElement(FaPlus, null), " Add Week")))), /*#__PURE__*/ React.createElement(CardBody, {
        unpadded: true
    }, /*#__PURE__*/ React.createElement(BreakdownTable, {
        parentId: itemRow.item.parentId,
        roles: itemRow.phasesBreakdown.roles,
        phases: itemRow.phasesBreakdown.phases,
        allPhases: itemRow.allPhases,
        data: itemRow.phasesBreakdown.data,
        onAllocationChange: onAllocationChange,
        onPhaseChange: onPhaseChange,
        onAddRole: onAddRole,
        onRemoveRole: onRemoveRole,
        onRoleChange: onRoleChange,
        allRoles: itemRow.allRoles,
        dispatch: dispatch,
        effortUnit: effortUnit,
        customComponents: customComponents,
        hideDropdownsRow: hideDropdownsRow
    })))));
};
ItemRow.propTypes = {
    dispatch: propTypes.func.isRequired,
    dragHandleProps: propTypes.object,
    innerRef: propTypes.oneOfType([
        propTypes.func,
        propTypes.object
    ]),
    selectedRegion: propTypes.string,
    renderHeader: propTypes.func,
    getDiscount: propTypes.func,
    getAddonPrice: propTypes.func,
    formatCurrency: propTypes.func,
    displayItemRowControls: propTypes.bool,
    displayDiscountedPrice: propTypes.bool,
    customComponents: propTypes.array,
    itemRow: propTypes.shape({
        item: propTypes.shape({
            name: propTypes.string,
            phase: propTypes.object,
            parentId: propTypes.number
        }),
        isExpanded: propTypes.bool,
        allPhases: propTypes.array,
        allRoles: propTypes.array,
        phasesBreakdown: propTypes.shape({
            data: propTypes.arrayOf(propTypes.array),
            roles: propTypes.array,
            phases: propTypes.arrayOf(propTypes.string)
        })
    }).isRequired,
    effortUnit: propTypes.string,
    usesDecimalNumbers: propTypes.bool,
    hideDropdownsRow: propTypes.bool
};
ItemRow.defaultProps = {
    renderHeader: defaultRenderHeader,
    displayItemRowControls: true
};
